'use strict';

function CnQuestionnairePagerController($q) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.move = move;

  function $onInit() {
    vm.onChange = vm.onChange() || $q.resolve;
    vm.active = false;
    vm.hideCompleted = vm.hideCompleted === true;
  }

  function move(to) {
    vm.active = true;
    return vm.onChange(to).then(function() { vm.active = false; });
  }
}

module.exports = CnQuestionnairePagerController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-questionnaire-pager/cn-questionnaire-pager.controller.js
 ** module id = 114
 ** module chunks = 0
 **/